<div class="alert alert-danger" role="alert">
    No se encontraron conisidencias!
</div>